module.exports = __webpack_public_path__ + "img/yangligz.456afb9c.png";